export const APP_URL = "https://app.angiolini.kz/";

export const WHATSAPP_PHONE = "77018017755";
export const WHATSAPP_MESSAGE =
  "Здравствуйте! Пишу с сайта Angiolini. Хочу подобрать верхнюю одежду.";
// Static fallback (used only if utm builder isn't imported).
// Prefer `buildWhatsAppUrl()` from `@/lib/utm` for links so UTM/source can be injected.
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE
)}`;
